export const PIPELINE_STAGE_TRACKING_KEY = {
	DOCUMENT_COLLECTION: 'document_collection',
	PETITION_FILED: 'petition_filed',
	PETITION_APPROVED: 'petition_approved',
	NVC_PROCESSING: 'nvc_processing',
	DOCUMENTARILY_QUALIFIED: 'documentarily_qualified',
	EMBASSY_INTERVIEW: 'embassy_interview',
	TRANSITION_USA_ARRIVAL: 'transition_usa_arrival',
	START_WORK: 'start_work',
}
